(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    class VideoBlock extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.video = this.querySelector('.media__video');
      this.playOverlay = this.querySelector('.media__play-overlay');

      if (!this.video) return;

      // Handle play button click
      if (this.playOverlay) {
        this.playOverlay.addEventListener('click', () => {
          this.video.controls = true;
          this.playOverlay.classList.add('hidden');
          this.video.play();
        });
      }

      // Handle video state changes
      this.video.addEventListener('play', () => {
        if (this.playOverlay) {
          this.playOverlay.classList.add('hidden');
        }
      });

      this.video.addEventListener('pause', () => {
        if (this.playOverlay) {
          this.playOverlay.classList.remove('hidden');
        }
      });

      this.video.addEventListener('ended', () => {
        if (this.playOverlay) {
          this.playOverlay.classList.remove('hidden');
        }
      });
    }

    connectedCallback() {
      // Reinitialize when block is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }
  }

  if (!customElements.get('video-block')) {
    customElements.define('video-block', VideoBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
